// SEO Keywords by Category for The Sealab

const SEO_KEYWORDS = {
    // Primary Keywords (High volume, competitive)
    PRIMARY: [
        "kitchen cabinets",
        "RTA cabinets",
        "ready to assemble cabinets",
        "pantry cabinets",
        "shaker cabinets",
        "kitchen remodeling",
        "cabinet hardware"
    ],

    // Long-tail Keywords (Lower volume, less competitive, higher intent)
    LONG_TAIL: [
        "ready to assemble kitchen cabinets",
        "RTA shaker kitchen cabinets",
        "white shaker kitchen cabinets",
        "kitchen cabinet doors and drawer fronts",
        "custom kitchen cabinet hardware",
        "kitchen pantry cabinet tall",
        "unfinished kitchen cabinets RTA",
        "soft close cabinet hinges",
        "kitchen cabinet crown molding",
        "cabinet filler strips"
    ],

    // Product-specific Keywords
    PRODUCTS: [
        "base kitchen cabinets",
        "wall kitchen cabinets",
        "tall pantry cabinets",
        "kitchen island cabinets",
        "corner kitchen cabinets",
        "lazy susan cabinets",
        "cabinet doors",
        "drawer fronts",
        "cabinet pulls",
        "cabinet knobs",
        "cabinet hinges",
        "crown molding",
        "filler panels"
    ],

    // Style Keywords
    STYLES: [
        "shaker style cabinets",
        "raised panel cabinets",
        "flat panel cabinets",
        "traditional kitchen cabinets",
        "modern kitchen cabinets",
        "transitional kitchen cabinets",
        "farmhouse kitchen cabinets"
    ],

    // Finish Keywords
    FINISHES: [
        "white kitchen cabinets",
        "gray kitchen cabinets",
        "natural wood cabinets",
        "painted kitchen cabinets",
        "stained kitchen cabinets",
        "espresso kitchen cabinets",
        "cherry kitchen cabinets",
        "maple kitchen cabinets",
        "oak kitchen cabinets"
    ],

    // Local SEO Keywords (if applicable)
    LOCAL: [
        "kitchen cabinets near me",
        "RTA cabinets online",
        "kitchen cabinet delivery",
        "cabinet installation",
        "kitchen remodeling contractors"
    ],

    // Buying Intent Keywords
    BUYING_INTENT: [
        "buy kitchen cabinets online",
        "kitchen cabinet sale",
        "discount kitchen cabinets",
        "affordable RTA cabinets",
        "kitchen cabinet deals",
        "kitchen cabinet pricing",
        "kitchen cabinet cost"
    ],

    // Problem-solving Keywords
    PROBLEM_SOLVING: [
        "kitchen cabinet replacement",
        "kitchen cabinet refacing",
        "how to install RTA cabinets",
        "kitchen cabinet assembly",
        "cabinet door replacement",
        "kitchen cabinet repair"
    ]
};

// Example usage in components:
const getKeywordsForPage = (pageType, productType = null) => {
    const base = SEO_KEYWORDS.PRIMARY.join(", ");

    switch (pageType) {
        case 'home':
            return [
                ...SEO_KEYWORDS.PRIMARY,
                ...SEO_KEYWORDS.LONG_TAIL.slice(0, 3),
                ...SEO_KEYWORDS.BUYING_INTENT.slice(0, 2)
            ].join(", ");

        case 'showroom':
            return [
                ...SEO_KEYWORDS.PRIMARY,
                ...SEO_KEYWORDS.STYLES,
                ...SEO_KEYWORDS.FINISHES.slice(0, 3)
            ].join(", ");

        case 'product':
            return [
                ...SEO_KEYWORDS.PRIMARY,
                ...SEO_KEYWORDS.PRODUCTS.slice(0, 5),
                ...SEO_KEYWORDS.BUYING_INTENT.slice(0, 2)
            ].join(", ");

        case 'gallery':
            return [
                "kitchen cabinet gallery",
                "cabinet design ideas",
                "kitchen cabinet inspiration",
                ...SEO_KEYWORDS.STYLES,
                ...SEO_KEYWORDS.FINISHES.slice(0, 3)
            ].join(", ");

        default:
            return base;
    }
};

export {SEO_KEYWORDS, getKeywordsForPage};